import { PressCoverageItem } from "./PressCoverageItem";

export { PressCoverageItem };
